<template>
  <div class="local-order-popup">
    <!-- 自定义 tooltip -->
    <div 
      v-if="tooltipVisible" 
      class="custom-tooltip-popup"
      :style="{
        left: tooltipPosition.x + 'px',
        top: tooltipPosition.y + 'px'
      }"
    >
      {{ tooltipContent }}
    </div>
    
    <!-- 图表区域 -->
    <div class="chart-container">
      <!-- <div class="chart-header">
        <div class="chart-title">订单趋势分析</div>
      </div> -->
      <div
        id="echarts"
        ref='echarts'
        class="chart-content"
      ></div>
    </div>
    
    <!-- 表格区域 -->
    <div class="table-container" v-if="level !== 'ad'">
      <!-- <div class="table-header">
        <h4 class="table-title">详细数据</h4>
      </div> -->
      <el-table
        :data="dailyStatsDesc"
        border
        stripe
        max-height="260"
        class="data-table"
        style="width: 100%;"
        :header-cell-style="{ 
          backgroundColor: '#f8f9fa', 
          color: '#495057',
          fontWeight: '600',
          fontSize: '13px',
          padding: '12px 8px'
        }"
        :cell-style="{ 
          padding: '10px 8px',
          fontSize: '13px'
        }"
      >
        <el-table-column
          property="dateStr"
          label="日期"
          width="110"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <div class="date-cell">
              <i class="el-icon-date" style="margin-right: 4px; color: #909399;"></i>
              {{ scope.row.dateStr }}
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="daySpend"
          :label="`每日花费`"
          width="90"
        >
          <template slot-scope="scope">
            <div class="spend-cell">
              <span class="spend-amount">{{ (scope.row.daySpend || 0).toFixed(2) }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="localOrder"
          :width="getColumnWidth('localOrder')"
        >
          <template slot="header">
            <div class="header-with-tooltip">
              <span class="header-text">系列订单</span>
              <span 
                class="tooltip-icon custom-tooltip-trigger" 
                @mouseenter="showTooltip($event, localOrderTitle)"
                @mouseleave="hideTooltip"
              >?</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="order-cell">
              <span class="order-valid">{{ scope.row.validLocalOrder }}</span>
              <span class="order-separator">/</span>
              <span class="order-total">{{ scope.row.localOrder }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="localOrderCost"
          :label="`订单成本`"
          width="120"
        >
          <template slot-scope="scope">
            <div class="cost-cell">
              <div class="cost-valid">{{ (scope.row.validLocalOrderCost || 0).toFixed(2) }}</div>
              <div class="cost-separator">/</div>
              <div class="cost-total">{{ (scope.row.localOrderCost || 0).toFixed(2) }}</div>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="saleOrder"
          :width="getColumnWidth('saleOrder')"
        >
          <template slot="header">
            <div class="header-with-tooltip">
              <span class="header-text">商品订单</span>
              <span 
                class="tooltip-icon custom-tooltip-trigger" 
                @mouseenter="showTooltip($event, saleOrderTitle)"
                @mouseleave="hideTooltip"
              >?</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="order-cell">
              <span class="order-valid">{{ scope.row.saleValidOrder }}</span>
              <span class="order-separator">/</span>
              <span class="order-total">{{ scope.row.saleOrder }}</span>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="saleOrderCost"
          :label="`商品订单成本`"
          width="120"
        >
          <template slot-scope="scope">
            <div class="cost-cell">
              <div class="cost-valid">{{ (scope.row.saleValidOrderCost || 0).toFixed(2) }}</div>
              <div class="cost-separator">/</div>
              <div class="cost-total">{{ (scope.row.saleOrderCost || 0).toFixed(2) }}</div>
            </div>
          </template>
        </el-table-column>
        
        <el-table-column
          property="nativeOrder"
          :width="getColumnWidth('nativeOrder')"
        >
          <template slot="header">
            <div class="header-with-tooltip">
              <span class="header-text">自然订单</span>
              <span 
                class="tooltip-icon custom-tooltip-trigger" 
                @mouseenter="showTooltip($event, nativeOrderTitle)"
                @mouseleave="hideTooltip"
              >?</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div class="order-cell">
              <span class="order-valid">{{ scope.row.validNativeOrder }}</span>
              <span class="order-separator">/</span>
              <span class="order-total">{{ scope.row.nativeOrder }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    level: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    },
    currency: {
      type: String,
      default: 'USD'
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tooltipContent: '',
      tooltipPosition: { x: 0, y: 0 }
    };
  },
  computed: {
    // 系列订单的提示文字
    localOrderTitle() {
      return "系列有效订单/系列成交订单\n" +
        "• 有效订单：当前系列客户提交有效订单+待审核订单\n" +
        "• 成交订单：当前系列客户提交订单数\n" +
        "大数据提供5分钟更新一次";
    },
    // 商品订单的提示文字
    saleOrderTitle() {
      return "商品有效订单/商品成交订单\n" +
        "• 有效订单：同商品同优化师所有系列客户提交有效订单+待审核订单\n" +
        "• 成交订单：同商品同优化师所有系列客户提交订单数\n" +
        "• 系列关联关系推广类型是站点时，商品订单以及成本展示--\n" +
        "大数据提供5分钟更新一次";
    },
    // 自然订单的提示文字
    nativeOrderTitle() {
      return "自然订单说明\n" +
        "系列关联关系中推广的商品，计算相同商品但是来源是native的订单数。\n" +
        "系列关联关系推广类型是站点时，自然订单展示--";
    },
    dailyStatsDesc() {
      if (!this.data) return [];
      let d = [];
      for (let i = this.dailyStats.length; i > 0; i--) {
        d.push(this.dailyStats[i - 1]);
      }
      return d;
    },
    dailyStats() {
      return (this.data && this.data.dailyStats) || [];
    },
  },
  methods: {
    showTooltip(event, content) {
      this.tooltipContent = content;
      this.tooltipVisible = true;
      
      const rect = event.target.getBoundingClientRect();
      this.tooltipPosition = {
        x: rect.left + rect.width / 2,
        y: rect.top - 10
      };
    },
    hideTooltip() {
      this.tooltipVisible = false;
      this.tooltipContent = '';
    },
    getColumnWidth(fieldKey) {
      // 根据字段返回合适的列宽
      const widthMap = {
        daySpend: 110,
        localOrder: 120,
        localOrderCost: 150,
        saleOrder: 120,
        saleOrderCost: 150,
        nativeOrder: 130,
      };
      return widthMap[fieldKey] || 110;
    },
    drawEcharts() {
      var chartDom = this.$refs.echarts;
      if (!chartDom) return;
      var myChart = this.$echarts.init(chartDom);

      // 调试：打印数据结构
      console.log('dailyStats data:', this.dailyStats);
      if (this.dailyStats.length > 0) {
        console.log('first item keys:', Object.keys(this.dailyStats[0]));
      }

      var option;
      option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderColor: '#e9ecef',
          borderWidth: 1,
          textStyle: {
            color: '#495057',
            fontSize: 12
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          data:
            this.level == 'campaign'
              ? [
                  '订单',
                  '有效订单',
                  '商品订单',
                  '商品有效订单',
                  '自然订单',
                  '自然有效订单',
                ]
              : [
                  '订单',
                  '有效订单',
                  '商品订单',
                  '商品有效订单',
                  '自然订单',
                  '自然有效订单',
                ],
          top: 10,
          textStyle: {
            fontSize: 12,
            color: '#495057'
          },
          itemWidth: 14,
          itemHeight: 14
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dailyStats.map((v) => v.dateStr),
          axisLabel: {
            fontSize: 11,
            color: '#6c757d',
            rotate: 0
          },
          axisLine: {
            lineStyle: {
              color: '#e9ecef'
            }
          },
          axisTick: {
            lineStyle: {
              color: '#e9ecef'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontSize: 11,
            color: '#6c757d'
          },
          axisLine: {
            lineStyle: {
              color: '#e9ecef'
            }
          },
          axisTick: {
            lineStyle: {
              color: '#e9ecef'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#f8f9fa',
              type: 'dashed'
            }
          }
        },
        series:
          this.level == 'campaign'
            ? [
                {
                  name: '订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#6c9bd1'
                  },
                  itemStyle: {
                    color: '#6c9bd1'
                  },
                  data: this.dailyStats.map((v) => v.localOrder || v.lo || 0),
                },
                {
                  name: '有效订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#7cb342'
                  },
                  itemStyle: {
                    color: '#7cb342'
                  },
                  data: this.dailyStats.map((v) => v.validLocalOrder || v.vlo || 0),
                },
                {
                  name: '商品订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#ffb74d'
                  },
                  itemStyle: {
                    color: '#ffb74d'
                  },
                  data: this.dailyStats.map((v) => v.saleOrder || v.so || 0),
                },
                {
                  name: '商品有效订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#e57373'
                  },
                  itemStyle: {
                    color: '#e57373'
                  },
                  data: this.dailyStats.map((v) => v.saleValidOrder || v.vso || 0),
                },
                {
                  name: '自然订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#4db6ac'
                  },
                  itemStyle: {
                    color: '#4db6ac'
                  },
                  data: this.dailyStats.map((v) => v.nativeOrder || v.no || 0),
                },
                {
                  name: '自然有效订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#81c784'
                  },
                  itemStyle: {
                    color: '#81c784'
                  },
                  data: this.dailyStats.map((v) => v.validNativeOrder || v.vno || 0),
                },
              ]
            : [
                {
                  name: '订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#6c9bd1'
                  },
                  itemStyle: {
                    color: '#6c9bd1'
                  },
                  data: this.dailyStats.map((v) => v.localOrder || v.lo || 0),
                },
                {
                  name: '有效订单',
                  type: 'line',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 6,
                  lineStyle: {
                    width: 2,
                    color: '#7cb342'
                  },
                  itemStyle: {
                    color: '#7cb342'
                  },
                  data: this.dailyStats.map((v) => v.validLocalOrder || v.vlo || 0),
                },
              ],
      };
      myChart.setOption(option);
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(val) {
        if (val) {
            this.$nextTick(()=> {
                this.drawEcharts();
            })
        }
      },
    },
  },
};
</script>

<style scoped>
.local-order-popup {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

/* 图表区域样式 */
.chart-container {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 10px;
  border-bottom: 1px solid #e9ecef;
}

.chart-header {
  margin-bottom: 16px;
  text-align: center;
}

.chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.chart-title::before {
  content: '📊';
  font-size: 18px;
}

.chart-subtitle {
  font-size: 12px;
  color: #6c757d;
  margin: 0;
}

.chart-content {
  width: 100%;
  height: 200px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 表格区域样式 */
.table-container {
  padding: 0px;
  padding-top: 10px;
  flex: 1;
  overflow-y: auto; /* 表格区域可滚动 */
  min-height: 0; /* 允许flex子元素缩小 */
}

.table-header {
  margin-bottom: 16px;
}

.table-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-title::before {
  content: '📋';
  font-size: 16px;
}

.data-table {
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 表格单元格样式 */
.date-cell {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}

.spend-cell {
  text-align: right;
}

.spend-amount {
  color: #495057;
}

.order-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.order-valid {
  color: #495057;
}

.order-separator {
  color: #495057;
  margin: 0 2px;
}

.order-total {
  color: #495057;
}

.cost-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 12px;
}

.cost-valid {
  color: #495057;
}

.cost-separator {
  color: #495057;
  margin: 0 2px;
}

.cost-total {
  color: #495057;
}

/* 表头样式 */
.header-with-tooltip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.header-text {
  font-weight: 600;
  color: #495057;
}

.tooltip-icon {
  color: #909399 !important;
  cursor: help;
  font-size: 12px !important;
  transition: color 0.2s ease;
  display: inline-block !important;
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border: 1px solid #909399;
  border-radius: 50%;
  background-color: #fff;
  font-weight: bold;
  margin-left: 4px;
}

.tooltip-icon:hover {
  color: #6c757d !important;
  border-color: #6c757d;
}

/* Tooltip内容样式 */
.tooltip-content {
  max-width: 280px;
  line-height: 1.5;
}

.tooltip-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e9ecef;
}

.tooltip-item {
  margin: 4px 0;
  color: #495057;
  font-size: 13px;
}

.tooltip-footer {
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #e9ecef;
  font-size: 12px;
  color: #6c757d;
  font-style: italic;
}

/* 表格行悬停效果 */
.data-table ::v-deep .el-table__row:hover > td {
  background-color: #f8f9fa !important;
}

/* 表格边框优化 */
.data-table ::v-deep .el-table td,
.data-table ::v-deep .el-table th {
  border-color: #e9ecef;
}

.data-table ::v-deep .el-table--border::after,
.data-table ::v-deep .el-table--group::after,
.data-table ::v-deep .el-table::before {
  background-color: #e9ecef;
}

/* 响应式调整 */
@media (max-width: 1000px) {
  .chart-content {
    width: 100%;
    min-width: 700px;
  }
}
</style>

<style>
/* 自定义 tooltip 弹窗 */
.custom-tooltip-popup {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-line;
  z-index: 9999;
  min-width: 200px;
  max-width: 300px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  transform: translateX(-50%) translateY(-100%);
  pointer-events: none;
}

.custom-tooltip-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
}

/* 自定义黑底白字 tooltip 样式 */
.custom-tooltip-trigger {
  position: relative;
  cursor: help;
}

.custom-tooltip-trigger::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  white-space: pre-line;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  pointer-events: none;
  min-width: 200px;
  max-width: 300px;
  text-align: left;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  margin-bottom: 8px;
}

.custom-tooltip-trigger::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s, visibility 0.3s;
  margin-bottom: 3px;
}

.custom-tooltip-trigger:hover::before,
.custom-tooltip-trigger:hover::after {
  opacity: 1;
  visibility: visible;
}

/* 全局tooltip样式 */
.custom-tooltip {
  background: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.custom-tooltip .popper__arrow {
  border-top-color: #dee2e6 !important;
}

.custom-tooltip .popper__arrow::after {
  border-top-color: #f8f9fa !important;
}
</style>
